import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type Language = "en" | "ar";
export type Direction = "ltr" | "rtl";

export function directionFor(language: Language): Direction {
  return language === "ar" ? "rtl" : "ltr";
}

interface LanguageState {
  readonly language: Language;
  setLanguage(language: Language): void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      // Arabic is the product's primary language; English is the opt-in.
      language: "ar",
      setLanguage: (language) => {
        if (typeof document !== "undefined") {
          document.documentElement.lang = language;
          document.documentElement.dir = directionFor(language);
        }
        set({ language });
      },
    }),
    {
      name: "nasam-language",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
